import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FileUpload } from '@Types/index';
import { RcFile } from 'antd/es/upload';

const getDefaultState = () => ({
  uploadedFile: {} as RcFile,
  formData: {} as FormData,
  filepath: '',
});

interface fileUploadState {
  file: FileUpload;
  isSaved: boolean;
}

const initialState: fileUploadState = {
  file: getDefaultState(),
  isSaved: false,
};

const fileUploadSlice = createSlice({
  name: 'activeSideMenu',
  initialState,
  reducers: {
    setFile: (
      state: fileUploadState,
      action: PayloadAction<fileUploadState['file'] | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.file = getDefaultState();
        state.isSaved = true;
      } else {
        state.file = payload;
        state.isSaved = false;
      }
    },
  },
});

const { actions } = fileUploadSlice;

export const fileUploadActions = {
  ...actions,
};

export default fileUploadSlice;
